import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { connectWithSocketIOServer, socket } from "../src/client/wss";
import "./App.css";
import { getSessionId } from "./client/sessionSetup";
import Home from "./Home/Home";
import appstore from "./store/appStore";
import { ProductProvider } from "./Home/components/ProductContext";

function App() {
  const  {setBotSessionId,setCartId,setOrigin,setHref}=appstore()
  // const id = document.getElementById("chatBot").getAttribute("data-value");
  // const id = "66c5e0b44e27d91343aa4cf3";
  // const id = "673c37ff71fc1e546015c46c";
  // const id = "66c5e0b44e27d91343aa4cf3";
  
  // const id = "66379b5267df461925f72763";
const [botId,setBotId]=useState("")
const [sessionId,setSessionId]=useState("")
  useEffect(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("botId");
    const session=urlParams.get("sessionId")
    const cartId=urlParams.get("cartId")
    const origin =urlParams.get('origin')
    const href=urlParams.get('href')
    setBotId(myParam)
    setSessionId(session)
    setBotSessionId(session)
    setCartId(cartId)
    setOrigin(origin)
    setHref(href)
    // if (!localStorage.getItem("sessionUUID")) {
    //   localStorage.setItem("sessionUUID", uuidv4().toString());
    // }
    // getSessionId(localStorage.getItem("sessionUUID"));
    connectWithSocketIOServer();
    return () => {
      socket.off("connect");
    };
  }, []);

  return (
    <Box className="App">
        <ProductProvider>
      {botId?<Home botid={botId} />:<></>}
      </ProductProvider>
    </Box>
  );
}

export default App;
